// Shared testimonial data, extracted from the homepage carousel
// (client/src/screens/Landing/components/sections/Testimonial.js) so the
// same real, verbatim testimonials can be reused as a `testimonial` section
// on marketing pages (see client/src/screens/Landing/views/MarketingPage.js).
//
// Do not invent, reword, or embellish any `text`, `author`, `role`, or
// `link` value here — these are real user reviews.

const testimonialImages = {
    viktoria: require('../screens/Landing/assets/images/testimonials/viktoria.webp'),
    yago: require('../screens/Landing/assets/images/testimonials/yago.webp'),
    mateus: require('../screens/Landing/assets/images/testimonials/mateus.webp'),
    svetlana: require('../screens/Landing/assets/images/testimonials/svetlana.webp'),
    lisa: require('../screens/Landing/assets/images/testimonials/lisa.webp'),
    royal_lobster: require('../screens/Landing/assets/images/testimonials/royal_lobster.png'),
    john_lovelace: require('../screens/Landing/assets/images/testimonials/john_lovelace.webp'),
    lino: require('../screens/Landing/assets/images/testimonials/lino.webp'),
    stefania_bianco: require('../screens/Landing/assets/images/testimonials/stefania_bianco.webp'),
    ashton_rogers: require('../screens/Landing/assets/images/testimonials/ashton_rogers.webp'),
    matias: require('../screens/Landing/assets/images/testimonials/matias.webp')
};

const TESTIMONIALS = [
    {
        id: 'stefania_bianco',
        text: "This is exactly what I've always been looking for! Before I had to use the autosend chat feature of Telegram and WhatsApp. I love that I can create folders and organize my notes according to topics, it helps a lot!",
        author: "Stefania Bianco",
        role: "User",
        avatar: testimonialImages.stefania_bianco
    },
    {
        id: 'viktoria',
        text: "Super happy with the app. Great design that can be adjusted by taste. Really good to organise thoughts but also capture moments in sound and picture. Moved from Evernote with pleasure.",
        author: "Viktoria",
        role: "Musician",
        avatar: testimonialImages.viktoria
    },
    {
        id: 'yago',
        text: "A unique way to take notes. I've finally found a note-taking app that truly fits my needs. It's packed with features, meticulously crafted, and developed by a community that listens to its users.",
        author: "yago",
        role: "Student",
        avatar: testimonialImages.yago,
        link: "https://play.google.com/store/apps/details?id=com.luckynote"
    },
    {
        id: 'mateus',
        text: "It works so well to organize all my bookmarks, todos, knowledge base, etc. I use it every day. The UX is great too.",
        author: "Mateus",
        role: "Developer & Kabbalah teacher",
        avatar: testimonialImages.mateus,
        link: "https://x.com/matmoura19"
    },
    {
        id: 'tina',
        text: "I like how Luckynote is practical at note taking unlike other note taking apps. It's exactly what I needed.",
        author: "Tina",
        role: "Content Creator"
    },
    {
        id: 'royal_lobster',
        text: "This is awesome. Useful for people who WhatsApp themselves. Finally found something that works!",
        author: "Royal_lobster",
        role: "Reddit user",
        link: "https://www.reddit.com/r/web_design/comments/qtqaab/ive_made_an_app_where_you_message_yourself_notes/hkphtwj/?context=3",
        avatar: testimonialImages.royal_lobster
    },
    {
        id: 'john_lovelace',
        text: "Exceptionally good for keeping self notes with time stamps. Great flow and style, a must have app in your arsenal.",
        author: "John T. Lovelace",
        role: "Business Owner",
        link: "https://play.google.com/store/apps/details?id=com.luckynote&reviewId=gp%3AAOqpTOFc7lonA3fgbPazLPPFqo5d9YSTOnm9PY4u76xPToXqCSK_YBbv_zVpwmfic_w7SUiLk9zOFciMIYHgKL0",
        avatar: testimonialImages.john_lovelace
    },
    {
        id: 'lisa_s',
        text: "I saw this app on Reddit and honestly, my mind is blown away! I used to send everything to myself through Telegram or WhatsApp but this is really good, congratulations.",
        author: "Lisa S",
        role: "Marketing Manager",
        link: "https://play.google.com/store/apps/details?id=com.luckynote&reviewId=gp%3AAOqpTOHnbYaV1sq7Kq0ag0LfJkkKYPP5PoByv8FX6XcQZT0QAgmqspqh8a96rjGin7LNLJ1TyHfk92zcaNSKs5M",
        avatar: testimonialImages.lisa
    },
    {
        id: 'spanish_user_video_feedback',
        text: "You have no idea how impressed I still am with the app. I used to look for the right way to save things, and I could never really find it. For example, I wanted to save a video and I just could not, for a bunch of reasons. In Capacities you cannot do that, so I had to upload it to Drive, copy the link, and keep it there. I could download the video and leave it in my gallery, but I would never see it again. In Google Keep I could not save videos either, plus so many other problems. What you did with the app is so simple, I can even play TikTok videos. It feels like magic. Thank you.",
        author: "Matias",
        role: "User",
        avatar: testimonialImages.matias
    },
];

function getTestimonialById(id) {
    return TESTIMONIALS.find((testimonial) => testimonial.id === id);
}

function getTestimonialsByIds(ids) {
    return (ids || [])
        .map((id) => getTestimonialById(id))
        .filter(Boolean);
}

module.exports = { TESTIMONIALS, getTestimonialById, getTestimonialsByIds };
